var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromocode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.846 17.845a.527.527 0 01-.746 0l-1.536-1.536a1.59 1.59 0 01-.298.108l-4.774 1.179a1.59 1.59 0 01-1.502-.416L.463 8.666a1.584 1.584 0 010-2.237L6.429.463a1.584 1.584 0 012.238 0L17.18 8.99c.39.39.55.966.416 1.502l-1.18 4.773a1.589 1.589 0 01-.106.298l1.536 1.536a.527.527 0 010 .746zm-1.273-7.608a.53.53 0 00-.139-.501L7.921 1.208a.528.528 0 00-.746 0L1.208 7.175a.528.528 0 000 .746l8.528 8.513a.53.53 0 00.5.139l4.484-1.107-1.27-1.27a1.585 1.585 0 01-1.8-.309 1.584 1.584 0 011.118-2.7c.406 0 .81.154 1.12.463.485.486.588 1.212.308 1.8l1.27 1.27 1.107-4.484zm-3.432 2.158a.528.528 0 100 .746.528.528 0 000-.746z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.666 11.65a1.584 1.584 0 01-2.237 0 1.584 1.584 0 010-2.237 1.584 1.584 0 012.237 0c.617.617.617 1.62 0 2.237zm-.745-1.491a.528.528 0 10-.746.747.528.528 0 00.746-.747zM9.412 6.43a1.581 1.581 0 11-2.237-2.238 1.581 1.581 0 112.237 2.237zm-.746-1.493a.527.527 0 10-.745.745.527.527 0 00.745-.745zM11.8 8.352a.527.527 0 01-.582.466l-6.712-.746a.527.527 0 11.117-1.048l6.712.745c.29.033.498.293.466.583z",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromocode);
export default __webpack_public_path__ + "static/media/promocode.86619b3f6ef46e7becb6635587c743fa.svg";
export { ForwardRef as ReactComponent };